export * from './feature-goals.component';
